var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "swap"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6489",
    "data-name": "Rectangle 6489",
    width: 49,
    height: 49,
    transform: "translate(0 49) rotate(-90)",
    fill: "#d7b16d",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239622",
    "data-name": "Path 239622",
    d: "M5.042,14.21H31.583l-3.267,2.45a2.042,2.042,0,0,0,2.45,3.267L38.933,13.8a2.042,2.042,0,0,0,0-3.246L31.053,4.43a2.044,2.044,0,1,0-2.511,3.226l3.205,2.47H5.042a2.042,2.042,0,1,0,0,4.083Z",
    transform: "translate(3.125 4.165)",
    fill: "#d7b16d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239623",
    "data-name": "Path 239623",
    d: "M37.7,19.125H11.16l3.267-2.45a2.042,2.042,0,0,0-2.45-3.267L3.81,19.533a2.042,2.042,0,0,0,0,3.246L11.691,28.9A2.044,2.044,0,0,0,14.2,25.679L11,23.208H37.7a2.042,2.042,0,0,0,0-4.083Z",
    transform: "translate(3.132 13.542)",
    fill: "#d7b16d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.8752ac3714b5f4cb1f222ec8e632547f.svg";
export { ForwardRef as ReactComponent };